import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import { Checkbox } from '../../../components/ui/Checkbox';

const AdvancedFilters = ({ filters, onFilterChange }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleCheckboxChange = (filterKey, checked) => {
    onFilterChange({ ...filters, [filterKey]: checked });
  };

  return (
    <div className="bg-card border border-border rounded-xl overflow-hidden">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full flex items-center justify-between p-4 md:p-6 hover:bg-muted transition-smooth focus:outline-none focus:ring-3 focus:ring-ring focus:ring-offset-3"
        aria-expanded={isExpanded}
      >
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center w-10 h-10 md:w-12 md:h-12 bg-secondary/10 rounded-lg">
            <Icon name="SlidersHorizontal" size={20} className="text-secondary" />
          </div>
          <div className="text-left">
            <h3 className="font-heading text-base md:text-lg font-semibold text-foreground">
              Advanced Filters
            </h3>
            <p className="caption text-muted-foreground">
              Additional venue requirements
            </p>
          </div>
        </div>
        <Icon 
          name={isExpanded ? "ChevronUp" : "ChevronDown"} 
          size={20} 
          className="text-muted-foreground transition-smooth"
        />
      </button>
      {isExpanded && (
        <div className="p-4 md:p-6 border-t border-border space-y-4 md:space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
            <Checkbox
              label="Wheelchair Accessible"
              description="Venues with accessibility features"
              checked={filters?.accessible || false}
              onChange={(e) => handleCheckboxChange('accessible', e?.target?.checked)}
            />

            <Checkbox
              label="Parking Available"
              description="On-site or nearby parking"
              checked={filters?.parking || false}
              onChange={(e) => handleCheckboxChange('parking', e?.target?.checked)}
            />

            <Checkbox
              label="WiFi Available"
              description="Free wireless internet access"
              checked={filters?.wifi || false}
              onChange={(e) => handleCheckboxChange('wifi', e?.target?.checked)}
            />

            <Checkbox
              label="Pet Friendly"
              description="Allows pets on premises"
              checked={filters?.petFriendly || false}
              onChange={(e) => handleCheckboxChange('petFriendly', e?.target?.checked)}
            />

            <Checkbox
              label="Outdoor Seating"
              description="Patio or outdoor area available"
              checked={filters?.outdoor || false}
              onChange={(e) => handleCheckboxChange('outdoor', e?.target?.checked)}
            />

            <Checkbox
              label="Open Now"
              description="Currently operating"
              checked={filters?.openNow || false}
              onChange={(e) => handleCheckboxChange('openNow', e?.target?.checked)}
            />
          </div>

          <div className="pt-4 border-t border-border">
            <div className="flex items-start gap-2 p-3 bg-muted/50 rounded-lg">
              <Icon name="Info" size={16} className="text-primary mt-0.5 flex-shrink-0" />
              <p className="text-xs md:text-sm text-muted-foreground">
                Applying multiple filters may reduce the number of available venues. Adjust your criteria if no results are found.
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdvancedFilters;